<div
  class="file-drop-zone"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <div
    class="drop-zone"
    [class.drop-zone--active]="dragOver()"
    (click)="browse()"
    role="button"
    tabindex="0"
    aria-label="Click or drag a file to upload"
  >
    @if (!selectedFile()) {
      <p class="app-text-body">
        Drop your {{ documentType() }} file here, or
        <span class="app-text-accent">browse</span>
        ({{ acceptList() }})
      </p>
    } @else {
      <p class="app-text-body">{{ selectedFile()!.name }}</p>
      <calcite-button appearance="transparent" scale="s" (click)="clear($event)">Clear</calcite-button>
    }
    <input
      #fileInput
      type="file"
      [attr.accept]="acceptList()"
      class="app-visually-hidden"
      (change)="onFileChange($event)"
      aria-label="File input"
    />
    <ng-content/>
  </div>
</div>
